import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';

//https://github.com/reddimohan/ionic-3-google-maps-autocomplete

@Injectable()
export class MapaProvider {
  app: any;
  google_api_key: any;

  contentHeader: Headers = new Headers({ 'Content-Type': 'application/json' });

  constructor(public http: HttpClient) {
    this.google_api_key = 'AIzaSyC3DZ1qXAb-Gz18pFGrofWGzo_SzR8RYYQ';
  }

  getAddress(params) {
    let url =
      'https://maps.googleapis.com/maps/api/geocode/json?key=' +
      this.google_api_key +
      '&latlng=' +
      params.lat +
      ',' +
      params.long;
    return this.http.get<any>(url).map((res) => <any>res);
  }

  getStreetAddress(params) {
    let url =
      'https://maps.googleapis.com/maps/api/geocode/json?key=' +
      this.google_api_key +
      '&latlng=' +
      params.lat +
      ',' +
      params.long +
      '&result_type=street_address';
    return this.http.get<any>(url).map((res) => <any>res);
  }

  GET(url) {
    return this.http.get(url).map((res) => res);
  }

  POST(url, params) {
    // let options = new RequestOptions({
    //   headers: this.contentHeader
    // });
    // return this.http.post(url, params, options).map(res => res.json());
  }

  DEL(url) {
    // let options = new RequestOptions({
    //   headers: this.contentHeader
    // });
    // return this.http.delete(url, options).map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/providers/mapa/mapa.ts